import { render, staticRenderFns } from "./value-config-list.vue?vue&type=template&id=154907f2&"
import script from "./value-config-list.vue?vue&type=script&lang=js&"
export * from "./value-config-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports